import {fetchCollectionCreate, guidesCountQueryOptions} from '@blesk-frontend/api';
import {useTeamSubscription} from '@blesk-frontend/auth';
import {Button, useModal} from '@blesk-frontend/ui';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useNavigate} from '@tanstack/react-router';
import {useMemo} from 'react';

import {PlanPaywallModal} from '@/features/plans';
import {shortDateTimeFormat} from '@/libs';
import {sendEvent} from '@/libs/analytics';

export const CollectionCreateButton = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const openPaywallModal = useModal((props) => <PlanPaywallModal {...props} />);

  const {subscription} = useTeamSubscription();
  const {data: count} = useQuery(guidesCountQueryOptions());

  const allowCreate = useMemo(() => {
    if (subscription?.plan?.name.toLowerCase().includes('team')) {
      return true;
    }

    return (count?.collections || 0) < 1;
  }, [count, subscription]);

  const onClickCreateCollection = async () => {
    const collection = await fetchCollectionCreate({
      name: `Новая коллекция ${shortDateTimeFormat.format(new Date()).replace(',', '')}`,
      description: 'Описание новой коллекции.',
    });
    sendEvent('collections/click-new');

    queryClient.invalidateQueries({queryKey: ['guides-count']});
    navigate({to: `/collections/${collection.id}`});
  };

  return (
    <Button
      className="px-6"
      onClick={() => (allowCreate ? onClickCreateCollection() : openPaywallModal())}
    >
      Новая коллекция
    </Button>
  );
};
